import {
  ListChecks,
  FileText,
  Download,
  History,
  Quote,
} from "lucide-react";
import type { SourceAction } from "../types";
import type { I18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

/**
 * PDF-specific action descriptors — fed to the universal
 * `<SourceActionsToolbar>` slot in `<SourceDrawer>`.
 */
export interface PDFActionsConfig {
  onExtractActionItems?: () => void;
  onSummarize?: () => void;
  onExport?: () => void;
  onVersioning?: () => void;
  onCiteAgain?: () => void;
}

export function buildPDFActions(cfg: PDFActionsConfig, i18n: I18n): SourceAction[] {
  return [
    {
      id: "extract-actions",
      label: i18n._(msg`Estrai action items`),
      icon: <ListChecks className="h-3.5 w-3.5" />,
      variant: "primary",
      disabled: !cfg.onExtractActionItems,
      onSelect: () => cfg.onExtractActionItems?.(),
    },
    {
      id: "summarize",
      label: i18n._(msg`Riassumi`),
      icon: <FileText className="h-3.5 w-3.5" />,
      disabled: !cfg.onSummarize,
      onSelect: () => cfg.onSummarize?.(),
    },
    {
      id: "export",
      label: i18n._(msg`Esporta`),
      icon: <Download className="h-3.5 w-3.5" />,
      disabled: !cfg.onExport,
      onSelect: () => cfg.onExport?.(),
    },
    {
      id: "versions",
      label: i18n._(msg`Versioning`),
      icon: <History className="h-3.5 w-3.5" />,
      disabled: !cfg.onVersioning,
      onSelect: () => cfg.onVersioning?.(),
    },
    {
      id: "cite-again",
      label: i18n._(msg`Cita anche [n]`),
      icon: <Quote className="h-3.5 w-3.5" />,
      disabled: !cfg.onCiteAgain,
      onSelect: () => cfg.onCiteAgain?.(),
    },
  ];
}
